import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Mail, Phone, CheckCircle2, MessageCircle } from 'lucide-react';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Contatti = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    nome: '',
    telefono: '',
    email: '',
    messaggio: '',
  });
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setErrorMsg('');
    try {
      await axios.post(`${API}/contact`, formData);
      setSubmitted(true);
      setFormData({ nome: '', telefono: '', email: '', messaggio: '' });
    } catch (err) {
      setErrorMsg(t('contatti.errorMsg'));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      className="contatti-page"
      style={{
        backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), url('https://images.pexels.com/photos/31898356/pexels-photo-31898356.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940')`,
      }}
    >
      <div className="top-bar" />
      <div className="contatti-container">
        <h1 className="page-title dark-text">{t('contatti.title')}</h1>

        <div className="contatti-info-grid">
          <div className="contact-info-card">
            <h3>{t('contatti.phone')}</h3>
            <a href="tel:+393314492862" className="contact-link">
              <Phone size={24} />
              <span>+39 331 449 2862</span>
            </a>
          </div>

          <div className="contact-info-card">
            <h3>{t('contatti.email')}</h3>
            <a href="mailto:sky.italia2023@gmail.com" className="contact-link">
              <Mail size={24} />
              <span>sky.italia2023@gmail.com</span>
            </a>
          </div>
        </div>

        {submitted ? (
          <div className="contact-thank-you" data-testid="contact-success">
            <CheckCircle2 size={56} className="thank-you-icon" />
            <h2 className="thank-you-title">{t('contatti.thanksTitle')}</h2>
            <p className="thank-you-text">{t('contatti.thanksText1')}</p>
            <p className="thank-you-text thank-you-text-secondary">
              {t('contatti.thanksText2Part1')} <strong>{t('contatti.thanksText2Bold')}</strong>{t('contatti.thanksText2Part2')}
            </p>
            <a
              href="https://wa.me/393314492862"
              className="thank-you-whatsapp"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="thank-you-whatsapp-btn"
            >
              <MessageCircle size={20} />
              <span>{t('contatti.whatsappBtn')}</span>
            </a>
            <button
              type="button"
              className="thank-you-back"
              onClick={() => setSubmitted(false)}
              data-testid="thank-you-back-btn"
            >
              {t('contatti.sendAnother')}
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="contact-form" data-testid="contact-form">
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="nome">{t('contatti.labelNome')}</label>
                <Input type="text" id="nome" name="nome" value={formData.nome} onChange={handleChange} required data-testid="contact-input-nome" />
              </div>

              <div className="form-group">
                <label htmlFor="telefono">{t('contatti.labelTelefono')}</label>
                <Input type="tel" id="telefono" name="telefono" value={formData.telefono} onChange={handleChange} required data-testid="contact-input-telefono" />
              </div>

              <div className="form-group">
                <label htmlFor="email">{t('contatti.labelEmail')}</label>
                <Input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required data-testid="contact-input-email" />
              </div>
            </div>

            <div className="form-group full-width">
              <label htmlFor="messaggio">{t('contatti.labelMessaggio')}</label>
              <Textarea id="messaggio" name="messaggio" value={formData.messaggio} onChange={handleChange} rows={6} required data-testid="contact-input-messaggio" />
            </div>

            {errorMsg && (
              <p className="form-error" data-testid="contact-error">{errorMsg}</p>
            )}

            <Button type="submit" className="submit-btn" disabled={submitting} data-testid="contact-submit-btn">
              {submitting ? t('contatti.submitting') : t('contatti.submit')}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
};

export default Contatti;
